module.exports = __webpack_public_path__ + "static/img/identification_1.616a117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/identification_1.png
// module id = d6th
// module chunks = 16